import Findable from '../mixins/Findable.js';
class AccountClient {
    static service = 'account';
    apiClient;
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    grantAdminPrivileges(params) {
        const endpoint = this.makeEndpoint('grant-admin-privileges');
        return this.apiClient.exec(endpoint, params);
    }
    revokeAdminPrivileges(params) {
        const endpoint = this.makeEndpoint('revoke-admin-privileges');
        return this.apiClient.exec(endpoint, params);
    }
    makeEndpoint(operation) {
        return `${AccountClient.service}/${operation}`;
    }
}
// Decorate service with mixins
const DecoratedClient = Findable(AccountClient);
export default DecoratedClient;
